﻿import { ProductVisitor } from './ProductVisitors.js';

export class UpdateMaterialImageVisitor extends ProductVisitor
{
    updateMaterialImage(component) {
        throw Error('The updateMaterialImage method must be overridden by a subclass');
    }

    visitDoorPanel(component) {
        this.updateMaterialImage(component);
    }

    visitDoorDivider(component) {
        this.updateMaterialImage(component);
    }

    visitDoorRail(component) {
        this.updateMaterialImage(component);
    }

    visitDoorStile(component) {
        this.updateMaterialImage(component);
    }

    visitDoorBottomTrack(component) {
        this.updateMaterialImage(component);
    }

    visitDoorTopTrack(component) {
        this.updateMaterialImage(component);
    }

    visitSideWall(component) {
        this.updateMaterialImage(component);
    }

    visitFlexiSide(component) {
        this.updateMaterialImage(component);
    }

    visitHangRodWithBrackets(component) {
        this.updateMaterialImage(component);
    }

    visitSupportRodWithBrackets(component) {
        this.updateMaterialImage(component);
    }

  visitFlexiBasketAndTracks(component) {
    this.updateMaterialImage(component);
  }

  visitMeshBasketAndTracks(component) {
    this.updateMaterialImage(component);
  }

    visitFlexiShelf(component) {
        this.updateMaterialImage(component);
    }

    visitTopShelf(component) {
        this.updateMaterialImage(component);
    }
}
